import React, { useEffect, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/user/selectors';
import { identifyUser } from 'utils/reporting';
import { initUserflow } from 'utils/userflow';
import { useNotificationService } from 'hooks/useNotificationService';
import { useExportNotificationsDeleteEvent } from 'hooks/useExportNotificationsDeleteEvent';
import { usePolicyManagerCompleteEvent } from 'hooks/usePolicyManagerCompleteEvent';

/**
 * The authenticated app chrome of the AMS mode: mounted only while the session
 * outcome is minted, so a cross-tab sign-out (which swaps the gate to the
 * SignedOut screen without navigating) stands these services down. Renders
 * nothing until the user lands in Redux — parity with the legacy gate.
 * useRefreshToken is deliberately absent: RenewalPolicy owns AMS renewal.
 */
export function AuthedAppServices({ children }: PropsWithChildren) {
  const user = useSelector(selectUser);

  useNotificationService();
  useExportNotificationsDeleteEvent();
  usePolicyManagerCompleteEvent();

  useEffect(() => {
    if (user) {
      identifyUser(user);
      initUserflow(user);
    }
  }, [user]);

  return user ? <>{children}</> : null;
}
